import Api from "~/service/Api";

class TaxRepository {
  fetch(query = {}) {
    return Api.get("/taxes", query);
  }
}

export default TaxRepository;
